import { useMutation } from '@tanstack/react-query'
import { UseBaseMutationOptions } from '@/core/api/type'
import { MessagingMutationKey } from '../../keys'
import MessagingService from '../services'
import {
	GetPlayerByConditionRequest,
	PlayerForMessagingModel,
} from '../../types'

function useMutationGroupPlayersByCondition(
	props?: UseBaseMutationOptions<
		PlayerForMessagingModel[],
		GetPlayerByConditionRequest
	>,
) {
	return useMutation({
		mutationKey: [MessagingMutationKey.GroupPlayersByCondition],
		mutationFn: (data: GetPlayerByConditionRequest) =>
			MessagingService.groupPlayersByCondition(data),
		...props,
	})
}

export default useMutationGroupPlayersByCondition
